import {
  ISetSelectedOpenRequisition,
  TMyOpenRolesActions,
} from 'modules/hiring/stateManagement/actions';
import * as constants from 'modules/hiring/stateManagement/constants';
import {
  IMyOpenRolesState,
  MY_OPEN_ROLES_INITIAL_STATE,
  TSelectedOpenRequisitionState,
} from 'modules/hiring/stateManagement/state';

export function myOpenRoles(
  state: IMyOpenRolesState = MY_OPEN_ROLES_INITIAL_STATE,
  action: TMyOpenRolesActions
): IMyOpenRolesState {
  switch (action.type) {
    case constants.GET_MY_OPEN_ROLES_STARTED: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case constants.GET_MY_OPEN_ROLES_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isFetching: false,
      };
    }

    case constants.GET_MY_OPEN_ROLES_FAILED: {
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    }
    default:
      return state;
  }
}

export function selectedOpenRequisition(
  state: TSelectedOpenRequisitionState = null,
  action: ISetSelectedOpenRequisition
): TSelectedOpenRequisitionState {
  switch (action.type) {
    case constants.SET_SELECTED_OPEN_REQUISITION: {
      return action.payload;
    }
    default:
      return state;
  }
}
